import React, { useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import styled from 'styled-components';

import ProfileUpdateContainer from 'containers/Menu/components/ProfileUpdateContainer';
import Column from 'components/common/Column';
import HackleManager from 'utils/hackle';
import { MAX_WIDTH } from 'App';
import ContentsTopBar from 'components/common/ContentsTopBar';
import WrapperContainer from 'components/common/Wrapper';
import { MENU_PATH } from 'constants/path';

const Container = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: ${props => (props.$isMobile ? '0 0 90px' : '0 0 40px')};
  width: 100%;
  max-width: 768px;
  min-height: ${props => (props.$isMobile ? 'auto' : '100vh')};
  background-color: #fff;
`;

const ProfilePage = () => {
  const { width, ref } = useResizeDetector();

  const isMobile = width ? width <= MAX_WIDTH : window.innerWidth <= MAX_WIDTH;

  useEffect(() => {
    HackleManager.logProfileView();
  }, []);

  return (
    <WrapperContainer isMobile={isMobile}>
      <Container ref={ref} $isMobile={isMobile}>
        <ContentsTopBar
          isMobile={isMobile}
          title="호스트 프로필 관리"
          path={MENU_PATH}
        />
        <Column>
          <ProfileUpdateContainer isMobile={isMobile} isPage={true} />
        </Column>
      </Container>
    </WrapperContainer>
  );
};

export default ProfilePage;
